var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { width: "40%", visible: _vm.checkedMealTimeBoxState },
          on: {
            "update:visible": function ($event) {
              _vm.checkedMealTimeBoxState = $event
            },
          },
        },
        [
          _c("add-product-dialog", {
            ref: "addProductDialog",
            attrs: {
              resourceObj: _vm.resourceObj,
              productObj: _vm.productObj,
              chenckBudgteObj: _vm.chenckBudgteObj,
              keyStr: _vm.keyStr,
            },
            on: { closeDialog: _vm.closeDialog },
            scopedSlots: _vm._u([
              {
                key: "addProductRightDiv",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c("span", { staticClass: "rightTop" }, [
                          _vm._v("住宿城市"),
                        ]),
                        _vm._l(
                          _vm.chenckBudgteObj.planDayList,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "dayList" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请选择最终需要入住的城市名称",
                                    size: "small",
                                  },
                                  model: {
                                    value: item.cityName,
                                    callback: function ($$v) {
                                      _vm.$set(item, "cityName", $$v)
                                    },
                                    expression: "item.cityName",
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }